'use strict';

var GridImportCsvButtonDirective = function GridImportCsvButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-import-csv-button.html'),
    controller: 'GridImportCsvButtonController'
  };
};
GridImportCsvButtonDirective.$inject = [];
module.exports = GridImportCsvButtonDirective;